import { Typography } from 'antd';
import { colors } from '@/variables';
import { FormattedMessage } from 'react-intl';
import { PageURL } from '@router/pageURL';

export const AppFooter = () => {
  return (
    <footer className={'mt-2 mb-6 flex items-center justify-center'}>
      <div className={'max-w-3xl'}>
        <div className={'copyright-wrapper flex justify-between'}>
          <div className={'copyright text-sm font-bold'}>
            <FormattedMessage id={'footer.copyright.title'} values={{ currentYear: new Date().getFullYear() }} />
          </div>
          <div className={'links flex gap-4'}>
            <Typography.Link
              href={PageURL.INTRODUCER_AGREEMENT}
              target={'_blank'}
              style={{ color: colors.primary }}
              className={'text-sm uppercase no-underline'}
            >
              <FormattedMessage id={'common.links.introducerAgreement'} />
            </Typography.Link>
            <Typography.Link
              href={PageURL.PRIVACY_POLICY}
              target={'_blank'}
              style={{ color: colors.primary }}
              className={'text-sm uppercase no-underline'}
            >
              <FormattedMessage id={'common.links.privacyPolicy'} />
            </Typography.Link>
          </div>
        </div>
        <div className={'description text-last-center mt-4 text-justify text-sm'}>
          <FormattedMessage id={'footer.copyright.description'} />
        </div>
      </div>
    </footer>
  );
};
